import { setTerm } from './helpers';

export const setWindowsType = setTerm('windows_type');
